import tw from 'tailwind-styled-components'

export const TwSkinsContainer = tw.div`
  flex
  flex-wrap
  gap-8
  items-start
`

export const TwListItemImg = tw.img<{$selected?: boolean}>`
  cursor-pointer
  w-118
  h-86
  min-w-118
  min-h-86
  max-w-118
  max-h-86
  relative
  box-border
  overflow-hidden
  z-0
  ${p => (p.$selected ? '' : 'rounded-4')}
`

export const TwListItem = tw.div<{$selected?: boolean}>`
  cursor-pointer
  w-118
  h-86
  relative
  box-border
  overflow-hidden
  z-0
  ${p => (p.$selected ? '' : 'rounded-4')}
`

export const TwSelected = tw.div`
  border-solid
  border-2
  border-notification-primary
  absolute
  top-[-2px]
  left-[-2px]
  z-1
  rounded-4
  cursor-default
  w-[calc(118px+4px)]
  h-[calc(86px+4px)]
  box-border
  overflow-hidden
`

export const TwTitle = tw.div`
  flex
  items-center
  text-sm-regular
  text-primary
  cursor-default
`

export const TwTitlePrimary = tw.div`
  text-primary
  text-sm-semibold
  cursor-default
`

export const TwTitleSecondary = tw.div`
  text-secondary
  text-sm-regular
  cursor-default
`

export const TwListItemButton = tw.div`
  flex
  items-center
  justify-center
  min-w-118
  min-h-86
  max-w-118
  max-h-86
`

export const TwCloseIcon = tw.div`
  z-10
  absolute
  top-2
  right-2
  rounded-50
  text-white
  cursor-pointer
  invisible
  group-hover:visible

  bg-[rgba(0,0,0,0.5)]
`
